import { useEffect, useState } from "react";
import { ReactComponent as FileIcon } from "../../../../assets/icons/file.svg";
import { ReactComponent as VerifiedIcon } from "../../../../assets/icons/verified.svg";
import { ReactComponent as UnverifiedIcon } from "../../../../assets/icons/unverified.svg";
import validateEmail from "../../../../utility/validator/email-validation";
import validatePhoneNumber from "../../../../utility/validator/phone-no-validation";
import UploadButton from "./upload-btn/upload-btn";
import * as bootstrap from "bootstrap";
import axios from "axios";
import FormData from "form-data";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import { MEMBER_OVERVIEW_ROUTE } from "../../dashboard-routes";
import { DASHBOARD_ROUTE } from "../../../../routes";
import normalizeDate from "../../../../utility/normalizeDate";
import formatDate from "../../../../utility/formatDate";
import DatePicker from "react-datepicker";

const AddMembers = ({ history }) => {
    const baseState = {
        fullName: "",
        type: "",
        role: "",
        licenseNumber: "",
        issue: "",
        expiry: "",
        CPDCompliant: "yes",
        mobileNumber: "",
        secondaryMobileNumber: "",
        email: "",
        secondaryEmail: "",
        memberType: "",
        CPDCertificate2018File: null,
        CPDCertificate2019File: null,
        CPDCertificate2020File: null,
        CPDCertificate2021File: null,
        orgId: authServices.getOrgId(),
        organisationId: authServices.getOrgId(),
    };

    const [formData, setFormData] = useState(baseState);
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [quotaAvailable, setQuotaAvailable] = useState(false);

    const [emailError, setEmailError] = useState(false);
    const [typeError, setTypeError] = useState(false);
    const [secondaryEmailError, setSecondaryEmailError] = useState(false);
    const [mobileNumberError, setMobileNumberError] = useState(false);
    const [secondaryMobileNumberError, setSecondaryMobileNumberError] = useState(false);

    const [error, setError] = useState("");
    const [sucess, setSucess] = useState("");

    function setFile(name, file) {
        //console.log(name, file);

        setFormData({
            ...formData,
            [name]: file,
        });
    }

    useEffect(()=>{
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    },[isFetching])

    useEffect(() => {
        console.log("ORG",authServices.getOrgId())
        setIsLoading(false);
    }, []);

    useEffect(() => {
        var config = {
            method: "get",
            url: dataProvider.baseUrl + "checkingSubscription",
            headers: {
                orgid: authServices.getOrgId(),
                token: authServices.getToken(),
            },
        };

        axios(config)
            .then(function (response) {
                setIsFetching(false);
                console.log(response.data);
                if(response.data.status === "success") {
                    setQuotaAvailable(true);
                }
            })
            .catch(function (error) {
                console.error(error);
                setIsFetching(false);
            });
    }, []);

    function postData() {
        var data = new FormData();

        for (var key in formData) {
            data.append(key, formData[key]);
        }

        data.append("currentMemberType", formData.memberType);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "addMember",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
            data: data,
        };
        setIsLoading(true);
        axios(config)
            .then(function (response) {
                // console.log(response);   
                setIsLoading(false);
                if (response.data.status === "success") {
                    setSucess("Member Added Successfully");
                    history.push(DASHBOARD_ROUTE + MEMBER_OVERVIEW_ROUTE);
                    //console.log(response.data);
                } else {
                    setError(response.data.message?.toString());
                    console.error(response.data);
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                setError(error.message);
                console.error(error);
            });
    }

    function handleSubmit(e) {
        e.preventDefault();

        setError("");
        setSucess("");

        if (document.activeElement) {
            document.activeElement.blur();
        }

        setTypeError(false);

        if (formData.type === "") {
            setTypeError(true);
            return false;
        }

        if (emailError || secondaryMobileNumberError || secondaryEmailError || mobileNumberError) {
            return false;
        }

        //console.log(formData);

        postData();

        return false;
    }

    return (
        <div id="add-members">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Add Members</div>
                    <div className="flex-fill"></div>
                    {isLoading ? (
                        <button
                            type="submit"
                            form="addMemberForm"
                            className="btn btn-primary text-white d-flex align-items-center"
                            disabled={true}
                        >
                            Saving
                            <div className="spinner-border spinner-border-sm ms-3" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                    ) : (
                        <button type="submit" form="addMemberForm" className="btn btn-primary text-white">
                            Save
                        </button>
                    )}
                </div>
            </div>

            <div className="container-fluid pt-3 px-3">
                {sucess && !error && (
                    <div className="alert alert-success" role="alert">
                        {sucess}
                    </div>
                )}
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                {!quotaAvailable && !isFetching && (
                    <div className="alert alert-info" role="alert">
                        You can not add more operators. Your plan limit is reached
                    </div>
                )}
            </div>

            {isFetching ? (
                <div className="container-fluid p-3 pt-0">
                    <div className="card p-5 d-flex align-items-center justify-content-center">
                        <div className="spinner-border text-primary ms-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3 pt-0">
                    <div className="card">
                        <div className="d-flex align-items-center border-bottom p-3">
                            <div>
                                <input
                                    value={formData.fullName}
                                    onChange={(e) => {
                                        setFormData({
                                            ...formData,
                                            fullName: e.target.value,
                                        });
                                    }}
                                    type="text"
                                    className="form-control border-0 no-border fw-bold"
                                    id="fullName"
                                    placeholder="Enter Full Name"
                                    required
                                    form="addMemberForm"
                                />
                            </div>
                            <div className="flex-fill"></div>
                            <button className="btn btn-outline border bg-light text-2 text-nowrap ms-3">
                                Find an Agent Details
                            </button>
                        </div>

                        <form id="addMemberForm" onSubmit={handleSubmit}>
                            <div className="container-fluid p-3">
                                <div className="row">
                                    <div className="col-xl">
                                        <div className="my-4">
                                            <label htmlFor="license-number" className="form-label">
                                                Licence/Certificate Number
                                            </label>
                                            <div className="input-group">
                                                <button
                                                    className="btn btn-outline-primary text dropdown-toggle"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    {formData.type ? formData.type : "Type"}
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li
                                                        onClick={(e) => {
                                                            setFormData({
                                                                ...formData,
                                                                type: "Class 1",
                                                            });
                                                            setTypeError(false);
                                                        }}
                                                        className="p-2 px-3"
                                                    >
                                                        Class 1
                                                    </li>
                                                    <li
                                                        onClick={(e) => {
                                                            setFormData({
                                                                ...formData,
                                                                type: "Class 2",
                                                            });
                                                            setTypeError(false);
                                                        }}
                                                        className="p-2 px-3"
                                                    >
                                                        Class 2
                                                    </li>
                                                    <li
                                                        onClick={(e) => {
                                                            setFormData({
                                                                ...formData,
                                                                type: "Assistant Agent",
                                                            });
                                                            setTypeError(false);
                                                        }}
                                                        className="p-2 px-3"
                                                    >
                                                        Assistant Agent
                                                    </li>
                                                </ul>
                                                <input
                                                    value={formData.licenseNumber}
                                                    onChange={(e) => {
                                                        setFormData({
                                                            ...formData,
                                                            licenseNumber: e.target.value,
                                                        });
                                                    }}
                                                    type="text"
                                                    className="form-control"
                                                    id="license-number"
                                                    placeholder="Enter License Number"
                                                    required
                                                />
                                            </div>

                                            {typeError && (
                                                <div className="position-absolute text-danger text-nowrap">
                                                    Please Select a Type
                                                </div>
                                            )}
                                        </div>

                                        <div className="my-4 position-relative">
                                            <label htmlFor="issue" className="form-label text-nowrap">
                                                Issue Date of License or Certificate:
                                            </label>
                                            {/* <input
                                            type="text"
                                            onFocus={(e) => {
                                                e.target.type = "date";
                                                e.target.click();
                                            }}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    issue: e.target.value,
                                                });
                                            }}
                                            onBlur={formatDate}
                                            className="form-control position-relative default"
                                            id="issue"
                                            placeholder="Enter Date for Issue"
                                            required
                                        /> */}
                                            <div className="position-relative">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    placeholderText="Issue Date"
                                                    selected={
                                                        isNaN(
                                                            new Date(parseInt(formData.issueInMilliSeconds)).getTime()
                                                        )
                                                            ? null
                                                            : new Date(parseInt(formData.issueInMilliSeconds))
                                                    }
                                                    onChange={(date) =>
                                                        setFormData((fs) => ({
                                                            ...fs,
                                                            issue: normalizeDate(date?.getTime() || ""),
                                                            issueInMilliSeconds: date?.getTime() || null,
                                                        }))
                                                    }
                                                />
                                                <div className="datepicker-icon"></div>
                                            </div>
                                        </div>

                                        <div className="my-4">
                                            <label htmlFor="mobile" className="form-label text-nowrap">
                                                Mobile Number
                                            </label>
                                            <input
                                                value={formData.mobileNumber}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        mobileNumber: e.target.value,
                                                    });
                                                    if (!validatePhoneNumber(e.target.value)) {
                                                        setMobileNumberError(true);
                                                    } else {
                                                        setMobileNumberError(false);
                                                    }
                                                }}
                                                type="text"
                                                className={"form-control " + (mobileNumberError ? "is-invalid" : "")}
                                                id="mobile"
                                                placeholder="Enter Mobile Number"
                                                required
                                            />
                                            {mobileNumberError && (
                                                <div className="position-absolute text-danger text-nowrap">
                                                    Invalid Mobile Number
                                                </div>
                                            )}
                                        </div>

                                        <div className="my-4">
                                            <label htmlFor="email" className="form-label text-nowrap">
                                                Email Address
                                            </label>
                                            <input
                                                value={formData.email}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        email: e.target.value,
                                                    });
                                                    if (!validateEmail(e.target.value)) {
                                                        setEmailError(true);
                                                    } else {
                                                        setEmailError(false);
                                                    }
                                                }}
                                                type="email"
                                                className={"form-control " + (emailError ? "is-invalid" : "")}
                                                id="email"
                                                placeholder="Enter Email Address"
                                                required
                                            />
                                            {emailError && (
                                                <div className="position-absolute text-danger text-nowrap">
                                                    Invalid Email Address
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xl">
                                        <div className="my-4">
                                            <label htmlFor="role" className="form-label">
                                                Role
                                            </label>
                                            <input
                                                value={formData.role}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        role: e.target.value,
                                                    });
                                                }}
                                                type="text"
                                                className="form-control"
                                                id="role"
                                                placeholder="Enter role"
                                                required
                                            />
                                        </div>

                                        <div className="my-4">
                                            <label htmlFor="expiry" className="form-label">
                                                Expiry
                                            </label>
                                            {/* <input
                                            type="text"
                                            onFocus={(e) => {
                                                e.target.type = "date";
                                            }}
                                            onChange={(e) => {
                                                setFormData({
                                                    ...formData,
                                                    expiry: e.target.value,
                                                });
                                            }}
                                            onBlur={formatDate}
                                            className="form-control position-relative default"
                                            id="expiry"
                                            placeholder="Enter Expiry Date"
                                            required
                                        /> */}
                                            <div className="position-relative">
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className="form-control"
                                                    selected={
                                                        isNaN(
                                                            new Date(parseInt(formData.expiryInMilliSeconds)).getTime()
                                                        )
                                                            ? null
                                                            : new Date(parseInt(formData.expiryInMilliSeconds))
                                                    }
                                                    placeholderText="Expiry Date"
                                                    onChange={(date) =>
                                                        setFormData((fs) => ({
                                                            ...fs,
                                                            expiry: normalizeDate(date?.getTime() || ""),
                                                            expiryInMilliSeconds: date?.getTime() || null,
                                                        }))
                                                    }
                                                />
                                                <div className="datepicker-icon"></div>
                                            </div>
                                        </div>

                                        <div className="my-4">
                                            <label htmlFor="secondary-mobile" className="form-label">
                                                Secondary Mobile Number
                                            </label>
                                            <input
                                                value={formData.secondaryMobileNumber}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        secondaryMobileNumber: e.target.value,
                                                    });
                                                    if (!validatePhoneNumber(e.target.value)) {
                                                        setSecondaryMobileNumberError(true);
                                                    } else {
                                                        setSecondaryMobileNumberError(false);
                                                    }
                                                }}
                                                type="text"
                                                className={
                                                    "form-control " + (secondaryMobileNumberError ? "is-invalid" : "")
                                                }
                                                id="secondary-mobile"
                                                placeholder="Enter Mobile Number"
                                                required
                                            />
                                            {secondaryMobileNumberError && (
                                                <div className="position-absolute text-danger">
                                                    Invalid Mobile Number
                                                </div>
                                            )}
                                        </div>

                                        <div className="my-4">
                                            <label htmlFor="secondary-email" className="form-label">
                                                Secondary Email Address
                                            </label>
                                            <input
                                                value={formData.secondaryEmail}
                                                onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        secondaryEmail: e.target.value,
                                                    });
                                                    if (!validateEmail(e.target.value)) {
                                                        setSecondaryEmailError(true);
                                                    } else {
                                                        setSecondaryEmailError(false);
                                                    }
                                                }}
                                                type="text"
                                                className={"form-control " + (secondaryEmailError ? "is-invalid" : "")}
                                                id="secondary-email"
                                                placeholder="Enter Secondary Email Address"
                                                required
                                            />
                                            {secondaryEmailError && (
                                                <div className="position-absolute text-danger">
                                                    Invalid Email Address
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xl">
                                        <div className="my-4">
                                            <label htmlFor="CPD-compliant" className="form-label">
                                                CPD Compliant at Entry Date?
                                            </label>
                                            <select
                                                value={formData.CPDCompliant}
                                                onChange={(e) => {
                                                    //console.log(e.target.value);
                                                    setFormData({
                                                        ...formData,
                                                        CPDCompliant: e.target.value,
                                                    });
                                                }}
                                                className="form-control"
                                                id="CPD-compliant"
                                            >
                                                <option value="yes">Yes</option>
                                                <option value="no">No</option>
                                            </select>
                                        </div>

                                        <div className="my-4 position-relative">
                                            <label htmlFor="CPD-memberType" className="form-label">
                                                Member Type
                                            </label>
                                            <div className="position-relative">
                                                <select
                                                    value={formData.memberType}
                                                    onChange={(e) => {
                                                        setFormData({
                                                            ...formData,
                                                            memberType: e.target.value,
                                                        });
                                                    }}
                                                    className="form-control"
                                                    id="memberType"
                                                    style={{ paddingRight: "2.3rem" }}
                                                >
                                                    <option value="" disabled>Select Type</option>
                                                    <option disabled={!quotaAvailable} value="NominatedInCharge">Operator</option>
                                                    <option value="employee">Employee</option>
                                                </select>
                                                <div
                                                    className="position-absolute cursor-pointer top-0 end-0 d-flex align-items-center justify-content-center"
                                                    style={{ width: "2.3rem", height: "2.3rem" }}
                                                >
                                                    <i
                                                        data-bs-toggle="tooltip"
                                                        title="<b>Caution</b><br> 
                                                <span> Any person nominated as Operator will have full access to make
                                                changes within iComply</span>"
                                                        data-bs-placement="top"
                                                        data-bs-html="true"
                                                        className="material-icons text-black-50"
                                                    >
                                                        help
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="my-4">
                                    <b>Upload CPD Certificates:</b>
                                    <div className="d-flex" style={{ flexWrap: "wrap" }}>
                                        <div className="card border-0 p-2 me-4 mt-4">
                                            <FileIcon />
                                            <div className="mt-3">
                                                <b>2018 Certificate</b>
                                            </div>
                                            <hr className="m-0" />
                                            <div>CPD Check</div>
                                            {formData.CPDCertificate2018File ? <VerifiedIcon /> : <UnverifiedIcon />}

                                            <UploadButton
                                                setFile={setFile}
                                                name="CPDCertificate2018File"
                                                file={formData.CPDCertificate2018File}
                                            />
                                        </div>

                                        <div className="card border-0 border-start p-2 me-4 mt-4 ">
                                            <FileIcon />
                                            <div className="mt-3">
                                                <b>2019 Certificate</b>
                                            </div>
                                            <hr className="m-0" />
                                            <div>CPD Check</div>
                                            {formData.CPDCertificate2019File ? <VerifiedIcon /> : <UnverifiedIcon />}

                                            <UploadButton
                                                setFile={setFile}
                                                name="CPDCertificate2019File"
                                                file={formData.CPDCertificate2019File}
                                            />
                                        </div>

                                        <div className="card border-0 border-start p-2 me-4 mt-4">
                                            <FileIcon />
                                            <div className="mt-3">
                                                <b>2020 Certificate</b>
                                            </div>
                                            <hr className="m-0" />
                                            <div>CPD Check</div>
                                            {formData.CPDCertificate2020File ? <VerifiedIcon /> : <UnverifiedIcon />}
                                            <UploadButton
                                                setFile={setFile}
                                                name="CPDCertificate2020File"
                                                file={formData.CPDCertificate2020File}
                                            />
                                        </div>

                                        <div className="card border-0 border-start p-2 mt-4">
                                            <FileIcon />
                                            <div className="mt-3">
                                                <b>2021 Certificate</b>
                                            </div>
                                            <hr className="m-0" />
                                            <div>CPD Check</div>
                                            {formData.CPDCertificate2021File ? <VerifiedIcon /> : <UnverifiedIcon />}
                                            <UploadButton
                                                setFile={setFile}
                                                name="CPDCertificate2021File"
                                                file={formData.CPDCertificate2021File}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddMembers;
